// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3pOE5","label":"SetPasswdForm_label__3SQcT"};